import { render, staticRenderFns } from "./tableDir.vue?vue&type=template&id=055134d0&scoped=true"
import script from "./tableDir.vue?vue&type=script&lang=js"
export * from "./tableDir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055134d0",
  null
  
)

export default component.exports